import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

// 경로별 메뉴 이름 매핑
const ROUTE_TITLES: Record<string, string> = {
    '/': '홈',
    '/schedules': '일정 관리',
    '/schedules/new': '일정 생성',
    '/pets': '반려동물',
    '/houses': '하우스',
    '/houses/detail': '하우스',
    '/analytics': '이용분석',
    '/users': '고객 관리',
    '/settings': '설정',
    '/notifications': '알림',
    '/chat': '채팅',
    '/manager': '대시보드',
    '/manager/check-in': '체크인',
    '/login': '로그인',
    '/register': '회원가입',
};

// 설정 페이지 탭별 제목
const SETTINGS_TAB_TITLES: Record<string, string> = {
    'profile': '매니저 정보',
    'branch': '지점 정보',
    'consent': '동의서 관리',
};

const APP_NAME = 'Tailody Hosting';

/**
 * 현재 페이지에 따라 문서 제목을 동적으로 변경하는 훅
 */
export function useDocumentTitle() {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const pathname = location.pathname;
        let menuName = ROUTE_TITLES[pathname] || '홈';

        // 설정 페이지의 경우 탭에 따라 제목 변경
        if (pathname === '/settings') {
            const tab = searchParams.get('tab') || 'profile';
            const tabTitle = SETTINGS_TAB_TITLES[tab];
            if (tabTitle) {
                menuName = `설정 - ${tabTitle}`;
            }
        }

        document.title = `${APP_NAME} | ${menuName}`;
    }, [location.pathname, searchParams]);
}

/**
 * 커스텀 제목을 설정하는 훅
 */
export function useCustomTitle(title: string) {
    useEffect(() => {
        document.title = `${APP_NAME} | ${title}`;
    }, [title]);
}
